// ** react imports
import React, { useEffect } from 'react';

// ** router imports
import { Link } from 'react-router-dom';

// ** redux imports
import { useDispatch } from 'react-redux';
import {
  setEmailForForgotPassword,
  setIsForgotPassword,
} from '../../../redux/slices/users';

// ** validation imports
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// ** hooks
import { useForgotPassword } from '../../../hooks/apis/useUsers';

// ** components imports
import LoadingButton from '../../../components/common/Buttons/LoadingButton';

// ** enums imports
import { BUTTON_THEMES } from '../../../enums/common';

// ** images imports
import Logo from '../../../images/Logo.png';

const ForgotPasswordForm = props => {
  // props
  const {} = props;

  // custom hooks
  const { isForgotPasswordLoading, forgotPassword } = useForgotPassword();

  // hooks
  const dispatch = useDispatch();

  // validation schema
  const validationSchema = yup.object().shape({
    email: yup.string().email('Invalid email').required('Email is required'),
  });

  // react hook form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onTouched',
  });

  // form submit handler
  const onSubmit = async data => {
    const response = await forgotPassword(data);
    if (response.data.success) {
      dispatch(setIsForgotPassword(true));
      dispatch(setEmailForForgotPassword(data.email));
    }
  };

  return (
    <div className="md:w-1/2">
      <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">
        {/* Header */}
        <div className="flex-1">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
            {/* Logo */}
            <Link className="block" to="/">
              <div className="w-10 h-10">
                <img
                  src={Logo}
                  alt="Multi Tax"
                  className="h-full w-full object-contain"
                />
              </div>
            </Link>
          </div>
        </div>

        <div className="max-w-sm mx-auto w-full px-4 py-8">
          <h1 className="text-3xl text-gray-800 dark:text-gray-100 font-bold mb-6">
            Forgot your password
          </h1>
          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="space-y-4">
              <div>
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="email"
                >
                  Email Address*
                </label>

                <input
                  id="email"
                  className={`form-input w-full ${
                    errors.email
                      ? 'border-red-500 focus:ring-red-500 dark:border-red-600 dark:focus:ring-red-600'
                      : 'border-gray-300 focus:ring-indigo-500 dark:border-gray-700/60 dark:focus:ring-indigo-500/50'
                  }`}
                  type="email"
                  autoComplete="on"
                  {...register('email')}
                />
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.email.message}
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <LoadingButton
                type="submit"
                theme={BUTTON_THEMES.PRIMARY}
                isLoading={isForgotPasswordLoading}
              >
                Send OTP
              </LoadingButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
